import { applicationIsBrowserSelector } from "../store/application";
import { useSelector } from "../store";

export function useIsBrowser() {
  return useSelector(applicationIsBrowserSelector);
}
